export default "__VITE_ASSET__BSAj82VA__"